module.exports = __webpack_public_path__ + "static/img/PSC.8749aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PSC.png
// module id = Tan1
// module chunks = 1